import { useDispatch } from "react-redux";
import { ModalId } from "../../../../enums/modalId";
import { setOpenedModalId } from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";
import EyeIcon from "../../../../svg/eye";

interface AssistSessionScreenshotButtonProps {
  label: string;
  screenshotPath: string;
}

/**
 * Renders a pill button that opens a captured session screenshot.
 *
 * @param props - Button label and the storage path of the screenshot
 * @returns The screenshot button element
 */
const AssistSessionScreenshotButton = (
  props: AssistSessionScreenshotButtonProps,
) => {
  const dispatch = useDispatch<AppDispatch>();

  const openScreenshot = () => {
    dispatch(
      setOpenedModalId({
        id: ModalId.IMAGE_VIEWER_MODAL,
        metaData: { filePaths: props.screenshotPath },
      }),
    );
  };

  return (
    <button
      className="assist-screenshot-button flex max-w-full items-center gap-1.5 rounded-full border border-primaryGray-15 px-2 py-0.5 text-x-tiny text-primaryGray-7 transition-colors hover:border-primaryGray-13 hover:bg-primaryGray-16 hover:text-primaryGray-3"
      onClick={openScreenshot}
      type="button"
    >
      <EyeIcon width={12} height={12} color="#8a8a8a" className="shrink-0" />
      <span className="truncate">{props.label}</span>
    </button>
  );
};

export default AssistSessionScreenshotButton;
